import { render, staticRenderFns } from "./List-Invoice-Company.vue?vue&type=template&id=2ccd4bd4&scoped=true"
import script from "./List-Invoice-Company.vue?vue&type=script&lang=js"
export * from "./List-Invoice-Company.vue?vue&type=script&lang=js"
import style0 from "./List-Invoice-Company.vue?vue&type=style&index=0&id=2ccd4bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd4bd4",
  null
  
)

export default component.exports